import React, { Component } from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";

import NavHandleContainer from "../NavHandle/container";
import NavDrawerContainer from "../NavDrawer/container";

import styles from "./index.module.css";

class LayoutNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navOpen: false,
      chapters: props.chapters
    };
    this.onNavOpen = this.onNavOpen.bind(this);
    this.onNavClose = this.onNavClose.bind(this);
  }

  onNavOpen() {
    this.setState({ navOpen: true });
  }

  onNavClose() {
    this.setState({ navOpen: false });
  }

  render() {
    const { chapters } = this.state;
    // Use this to trigger a re-render in the NavDrawer when the location
    // changes.
    const { currentPath } = this.props;

    return (
      <div className={styles.root}>
        <div className={styles.handle}>
          <NavHandleContainer
            onNavOpen={this.onNavOpen}
            isOpen={this.state.navOpen}
            chapters={chapters}
          />
          <Transition in={this.state.navOpen} timeout={600}>
            {state => (
              <div>
                <div className={styles[`wrapper${state}`]} />
                <div className={styles[`drawer${state}`]}>
                  <div className={styles.drawerInner}>
                    <NavDrawerContainer
                      onNavClose={this.onNavClose}
                      chapters={chapters}
                      currentPath={currentPath}
                    />
                  </div>
                </div>
              </div>
            )}
          </Transition>
        </div>
      </div>
    );
  }
}

LayoutNav.propTypes = {
  currentPath: PropTypes.string,
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      titleNumber: PropTypes.string
    })
  )
};

export default LayoutNav;



// WEBPACK FOOTER //
// ./src/components/LayoutNav/index.js